<template>
  <ol class="breadcrumb" style="margin: 0; padding: 8px 20px 8px 20px">
    <li v-for="(breadcrumbItem, index) in breadcrumbItems" :class="{'breadcrumb-item': true, 'active': isItemActive(index)}">
      <span v-if="isItemActive(index)">{{breadcrumbItem.name}}</span>
      <a v-else href="#" @click.prevent="onItemClick(breadcrumbItem)">{{breadcrumbItem.name}}</a>
    </li>
  </ol>
</template>

<script setup>
import {defineProps} from 'vue'

const props = defineProps({
  breadcrumbItems: {
    type: Array,
    required: true
  }
})

const emit = defineEmits({
  'itemClick': (item) => item
});

const isItemActive = (itemIndex) => {
  return props.breadcrumbItems.length - itemIndex === 1;
};

const onItemClick = (item) => {
  emit('itemClick', item);
};
</script>
